import { CaseModel } from 'api/model';
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import {
  activeVehicleClassFlags,
  Chip,
  ChipIcon,
} from './vehicleClassificationChips';

const COMPACT_THRESHOLD_PX = 180;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  align-items: center;
  line-height: 1;
`;

const Empty = styled.span`
  color: #b6986a;
  font-size: 14px;
`;

const VehicleClassificationCell = ({ caseModel }: { caseModel: CaseModel }) => {
  const wrapperRef = useRef<HTMLDivElement | null>(null);
  const [compact, setCompact] = useState(false);

  useEffect(() => {
    const el = wrapperRef.current;
    if (!el) return undefined;

    const observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        setCompact(entry.contentRect.width < COMPACT_THRESHOLD_PX);
      });
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const flags = activeVehicleClassFlags(caseModel);
  if (flags.length === 0) {
    return (
      <Wrapper ref={wrapperRef}>
        <Empty>–</Empty>
      </Wrapper>
    );
  }

  return (
    <Wrapper ref={wrapperRef}>
      {flags.map((f) => (
        <Chip key={f.caseFlag} $tone={f.tone} $compact={compact} title={f.hint ?? f.label}>
          <ChipIcon icon={f.icon} $compact={compact} />
          {!compact && <span>{f.label}</span>}
        </Chip>
      ))}
    </Wrapper>
  );
};

export default VehicleClassificationCell;
